import React, { useState, useEffect } from 'react';

import Loader from 'components/Loader';
import AddressForm from 'containers/AccountBilling/shared/AddressForm';
import { initialAddressValue } from 'containers/AccountBilling/shared/AddressForm/schema';
import { transformAddressDataToFormdata } from 'containers/AccountBilling/shared/AddressForm/transformAddressDataToFormdata';
import { useFetchBillingDetails } from 'hooks/accountBilling/useFetchBillingDetails';

interface ICreateAddressProps {
  onClose: () => void;
}

const ChangeAddress: React.FC<ICreateAddressProps> = ({ onClose }) => {
  const [formData, setFormData] = useState<typeof initialAddressValue>(initialAddressValue);

  const { data, status } = useFetchBillingDetails();

  useEffect(() => {
    if (status === 'success') {
      const fetchedFormData = data?.payload?.billing_address;
      const formData = transformAddressDataToFormdata(fetchedFormData);

      setFormData(formData);
    }
  }, [status, data]);

  if (status === 'loading') return <Loader />;

  return <AddressForm formData={formData} onClose={onClose} />;
};
export default ChangeAddress;
